import {
  Component,
  OnInit,
  AfterViewChecked,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core'
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../environments/environment'
import { PdfChart } from '../../shared/pdfChart'
import { isNullOrUndefined } from 'util'
import { FormGroup, FormControl } from '@angular/forms';


@Component({
  selector: 'app-price-performance',
  templateUrl: './price-performance.component.html',
  styleUrls: ['./price-performance.component.scss']
})
export class PricePerformanceComponent implements OnInit {
  @Input() isFullFactSheet
  @Output() pricePerType = new EventEmitter()
  @Input() printTrading
  chartData = []
  listSecurityTrading = []
  securityTradings = []
  symbol
  period = 'YTD'
  printFirst = true
  printPage = false
  subscription: Subscription
  subscriptionPeriod: Subscription
  print = false
  pdf = false
  pdfChart: PdfChart = new PdfChart()
  indexPrice
  radios = [
    { value: '0', des: 'Local' },
    { value: '1', des: 'Foreign' }
  ]
  chartData1 = []
  chartData2 = []
  chartData3 = []
  chartData4 = []
  chart
  form: FormGroup
  radioValue: FormControl
  pricePer = '0'
  loadGraphFirstTime = true
  constructor(
    private amCharts: AmChartsService,
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) { }

  initialChart() {
    if (this.loadGraphFirstTime) {
    }
    this.loadGraphFirstTime = false
  }
  ngOnInit() {
    const { pdf, print } = this.activatedRoute.snapshot.data
    const { symbol } = this.activatedRoute.snapshot.params
    const { period } = this.activatedRoute.snapshot.params
    const { pricePerType } = this.activatedRoute.snapshot.params
    pdf === undefined ? (this.pdf = false) : (this.pdf = pdf)
    print === undefined ? (this.print = false) : (this.print = print)
    this.pdfChart.setPdf(pdf)
    // tslint:disable-next-line:no-unused-expression
    symbol !== undefined ? (this.symbol = symbol) : null
    // tslint:disable-next-line:no-unused-expression
    period !== undefined ? (this.period = period) : null
    // tslint:disable-next-line:no-unused-expression
    pricePerType !== undefined ? (this.pricePer = pricePerType) : null

    this.form = new FormGroup({
      radioValue: new FormControl(this.pricePer)
    })

    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.form.get('radioValue').setValue('0')
        this.symbol = response['securitySymbol']
        this.getSecurityTradingByPeriod(this.symbol, this.period)
      })

    this.subscriptionPeriod = this.store
      .getPeriodInputObservable()
      .subscribe(newPeriod => {
        if (newPeriod !== undefined) {
          this.period = newPeriod
        }
        if (this.symbol.toString().length > 0) {
          this.getSecurityTradingByPeriod(this.symbol, this.period)
        }
      })

    if (symbol !== undefined) {
      this.form.get('radioValue').setValue('0')
      this.getSecurityTradingByPeriod(symbol, period)
    } else {
      this.subscription = this.store
        .getSecurityProfileNewResultObservable()
        .subscribe(response => {
          if (!response) {
            return
          }
          this.form.get('radioValue').setValue('0')
          this.getSecurityTradingByPeriod(
            response['securitySymbol'],
            this.period
          )
        })
    }
    if (symbol !== undefined) {
      this.form.get('radioValue').setValue('0')
      this.getSecurityTradingByPeriod(symbol, period)
    } else {
      this.subscriptionPeriod = this.store
        .getPeriodInputObservable()
        .subscribe(newPeriodInput => {
          this.getSecurityTradingByPeriod(this.symbol, newPeriodInput)
        })
    }
    if (this.print || this.pdf) {
      this.printPage = true
    } else {
      this.printPage = false
    }
  }

  getSecurityTradingByPeriod(symbol, period) {
    this.listSecurityTrading = []
    // tslint:disable-next-line:no-unused-expression
    symbol !== undefined && period !== undefined
    const loadData = this.cpmService
      .getSecurityTradingByPeriod(symbol, period)
      .then(trading => {
        const divpricePerformance = document.getElementById('pricePerformance')
        if (trading.length === 0) {
          // tslint:disable-next-line:max-line-length
          this.chartData1 = [
            {
              securitySymbol: 'ABC',
              nativeType: 'L',
              lastPriceClose: '000',
              tradingDate: '2017-05-22T17:00:00.000+0000',
              change: '0',
              percentChange: '0.000',
              value: '50',
              volume: '0'
            }
          ]
          // tslint:disable-next-line:max-line-length
          this.chartData2 = [
            {
              securitySymbol: 'DEF',
              nativeType: 'L',
              lastPriceClose: '000',
              tradingDate: '2017-05-22T17:00:00.000+0000',
              change: '0',
              percentChange: '0.000',
              value: '0',
              volume: '0'
            }
          ]

          if (divpricePerformance !== null) {
            this.makeChart()
          }
          // this.makeChart()
        } else {
          this.chartData1 = trading.filter(
            tr => tr.securitySymbol === `${symbol}`
          )
          this.chartData2 = trading.filter(
            tr => tr.securitySymbol === `${symbol}-F`
          )
          if (divpricePerformance !== null) {
            this.makeChart()
            this.chart.mainDataSet = this.chart.dataSets[this.pricePer]
            this.chart.validateNow()
          }
          // this.makeChart()
        }
      })
  }

  makeChart() {
    this.chart = this.amCharts.makeChart('pricePerformance', {
      type: 'stock',
      theme: 'light',
      responsive: {
        enabled: true
      },
      categoryAxesSettings: {
        //
        minPeriod: 'mm',
        equalSpacing: true // delete space in graph
      },

      dataSets: [
        {
          color: '#fbb034',
          fieldMappings: [
            {
              fromField: 'lastPriceClose',
              toField: 'lastPriceClose'
            },
            {
              fromField: 'value',
              toField: 'value'
            },
            {
              fromField: 'volume',
              toField: 'volume'
            }
          ],
          dataProvider: this.chartData1,
          categoryField: 'tradingDate'
        },

        {
          // title: 'Foreign',
          color: '#fbb034',
          fieldMappings: [
            {
              fromField: 'lastPriceClose',
              toField: 'lastPriceClose'
            },
            {
              fromField: 'value',
              toField: 'value'
            },
            {
              fromField: 'volume',
              toField: 'volume'
            }
          ],
          dataProvider: this.chartData2,
          categoryField: 'tradingDate'
        }
      ],

      panels: [
        {
          showCategoryAxis: false,
          title: 'Price',
          percentHeight: 33,
          valueAxes: [{
            minimum: 0,
            minMaxMultiplier: 1.1
          }],
          stockGraphs: [
            {
              id: 'g1',
              valueField: 'lastPriceClose',
              cornerRadiusTop: 2,
              comparable: true,
              compareField: 'lastPriceClose',
              type: 'smoothedLine',
              balloonText: `${this.symbol}:<b>[[value]]</b>`,
              compareGraphBalloonText: '[[title]]:<b>[[value]]</b>',
              lineThickness: 3,
            }
          ],

          stockLegend: {
            // periodValueTextComparing: '[[percents.value.close]]%',
            periodValueTextRegular: '[[value.close]]',
            valueTextRegular: '',
            markerType: 'none'
          }
        },

        {
          showCategoryAxis: false,
          title: 'Value',
          percentHeight: 33,
          stockGraphs: [
            {
              valueField: 'value',
              type: 'column',
              cornerRadiusTop: 2,
              showBalloon: true,
              fillAlphas: 1,
              // balloonText: '[[title]]:<b>[[value]]</b>',
              balloonText: `[[value]]`,
              compareGraphBalloonText: '[[title]]:<b>[[value]]</b>'
            }
          ],

          stockLegend: {
            valueText: '[[value]] Baht',
            // ''[[value.close]] : Baht' '
            periodValueTextRegular: '[[value.close]] Baht',
            valueTextRegular: '',
            markerType: 'none'
          }
        },
        {
          title: 'Volume',
          percentHeight: 33,
          stockGraphs: [
            {
              valueField: 'volume',
              type: 'column',
              cornerRadiusTop: 2,
              showBalloon: true,
              fillAlphas: 1,
              // balloonText: '[[title]]:<b>[[value]]</b>',
              balloonText: '[[value]]',
              compareGraphBalloonText: '[[title]]:<b>[[value]]</b>'
            }
          ],

          stockLegend: {
            valueText: '[[value]] Shares',
            periodValueTextRegular: '[[value.close]] Shares',
            valueTextRegular: '',
            markerType: 'none'
          }
        }
      ],

      chartScrollbarSettings: {
        graph: 'g1',
        enabled: false
      },

      chartCursorSettings: {
        valueBalloonsEnabled: true,
        fullWidth: true,
        cursorAlpha: 0.1,
        valueLineBalloonEnabled: true,
        valueLineEnabled: true,
        valueLineAlpha: 0.1
      },

      panelsSettings: {
        usePrefixes: false
      }
    })
  }
  changeDataSet() {
    this.chart.mainDataSet = this.chart.dataSets[this.pricePer]
    this.chart.validateNow()
    this.pricePerType.emit(this.pricePer)
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/price-performance/price-performance.component.ts